module.exports = __webpack_public_path__ + "static/media/BHEL.fbd2a4d6.txt";